import React, { useState } from 'react'
import {
  Card,
} from "@/shared/ui/card"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/ui/popover"
import { Label } from "@/shared/ui/label"
import { cn } from "@/lib/utils"
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/shared/ui/calendar"
import { Button } from "@/shared/ui/button"
import { format, startOfDay, endOfDay } from "date-fns";
import { useTranslation } from 'react-i18next';

const DateRange = ({ buttonText, onSubmit, action }) => {
  const { t } = useTranslation();
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  const handleDateFromChange = (date) => {
    if (date) {
      setDateFrom(startOfDay(date));
    } else {
      setDateFrom(null);
    }
  };

  const handleDateToChange = (date) => {
    if (date) {
      setDateTo(endOfDay(date));
    } else {
      setDateTo(null);
    }
  };

  const handleSubmit = async () => {
    if (onSubmit) {
      await onSubmit({ dateFrom, dateTo, setDateFrom, setDateTo });
    }
  };

  return (
    <Card className="rounded-2xl w-full p-4">
      <div className="grid grid-cols-1 lg:grid-cols-[3fr_3fr_1fr] gap-4 items-end">
        <div>
          <Label className="text-sm font-semibold text-[#09090B] mb-2 block">
            {t("reports.filters.dateFrom")}
          </Label>
          <Popover>
            <PopoverTrigger asChild>
              <Button
                variant={"outline"}
                className={cn(
                  "w-full pl-3 text-left font-normal",
                  !dateFrom && "text-muted-foreground"
                )}
              >
                {dateFrom ? (
                  format(dateFrom, "dd.MM.yyyy")
                ) : (
                  <span>{t("profile.billing.pickStart")}</span>
                )}
                <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                selected={dateFrom}
                onSelect={handleDateFromChange}
                disabled={(date) =>
                  date > new Date() || date < new Date("1900-01-01")
                }
                initialFocus
              />
            </PopoverContent>
          </Popover>
        </div>
        
        <div>
          <Label className="text-sm font-semibold text-[#09090B] mb-2 block">
            {t("reports.filters.dateTo")}
          </Label>
          <Popover>
            <PopoverTrigger asChild>
              <Button
                variant={"outline"}
                className={cn(
                  "w-full pl-3 text-left font-normal",
                  !dateTo && "text-muted-foreground"
                )}
              >
                {dateTo ? (
                  format(dateTo, "dd.MM.yyyy")
                ) : (
                  <span>{t("profile.billing.pickEnd")}</span>
                )}
                <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                selected={dateTo}
                onSelect={handleDateToChange}
                disabled={(date) =>
                  date > new Date() || date < new Date("1900-01-01")
                }
                initialFocus
              />
            </PopoverContent>
          </Popover>
        </div>
        
        <Button 
          onClick={handleSubmit}
          disabled={!dateFrom || !dateTo}
          className={`${action === 'delete' && 'bg-red-500 hover:bg-red-600'}`}
        >
          {buttonText}
        </Button>
      </div>
    </Card>
  );
};

export default DateRange;
